"use client";

import { useTranslations } from "next-intl";

import type { ArticleMeta } from "@/integrations/articles";
import { cn } from "@/lib/utils/cn";

import { ArticleCard } from "./ArticleCard";

interface ArticleListProps {
  articles: ArticleMeta[];
  className?: string;
}

export function ArticleList({ articles, className }: ArticleListProps) {
  const t = useTranslations("pages.articles");

  if (articles.length === 0) {
    return (
      <div
        className={cn(
          "rounded-3xl border border-dashed border-paper-3 p-10 text-center",
          className,
        )}
      >
        <h2 className="font-heading text-2xl leading-tight text-ink">
          {t("emptyTitle")}
        </h2>
        <p className="mt-2 text-sm text-ink-2">{t("emptyBody")}</p>
      </div>
    );
  }

  return (
    <ul
      className={cn(
        "grid gap-10 sm:grid-cols-2 sm:gap-8 lg:grid-cols-3",
        className,
      )}
    >
      {articles.map((article) => (
        <li key={`${article.locale}-${article.slug}`}>
          <ArticleCard article={article} />
        </li>
      ))}
    </ul>
  );
}
